import React from 'react';
import '../../../components/layout/ModuleLayout.css';
import ConnectionTest from '../../../components/pages/ConnectionTest';
import ComponentRegistryTab from '../../../components/settings/ComponentRegistryTab';
import TestResultsTab from '../../../components/settings/TestResultsTab';
import SDLCManagement from '../../../components/settings/SDLCManagement';
import TestsTab from '../../../components/settings/TestsTab';
import WorkflowDemo from '../../../components/workflow/WorkflowDemo';
import GeneralTab from '../../../components/settings/GeneralTab';
import ComingSoon from '../../../components/common/ComingSoon';
import UserRolesTab from '../../../components/settings/UserRolesTab';
import Drawer from '../../../components/common/Drawer';
import { SettingsTabKey } from './SettingsTabs';

interface SettingsNetBodyProps {
  activeTab?: SettingsTabKey;
  asideOpen?: boolean;
  onAsideToggle?: () => void;
}

const SettingsNetBody: React.FC<SettingsNetBodyProps> = ({ activeTab = 'general', asideOpen = false, onAsideToggle }) => {
  const renderPanel = () => {
    if (activeTab === 'general')      return <GeneralTab />;
    if (activeTab === 'users')        return <UserRolesTab />;
    if (activeTab === 'connection')   return <ConnectionTest />;
    if (activeTab === 'components')   return <ComponentRegistryTab />;
    if (activeTab === 'test-results') return <TestResultsTab />;
    if (activeTab === 'sdlc')         return <SDLCManagement />;
    if (activeTab === 'tests')        return <TestsTab />;
    if (activeTab === 'generic')      return <WorkflowDemo />;
    return <ComingSoon />;
  };

  return (
    <div className="module-layout">
      <div className="module-main">
        <div className="tab-content">
          <section role="tabpanel" className="tab-panel show">
            {renderPanel()}
          </section>
        </div>
      </div>
      <Drawer isOpen={asideOpen} onClose={onAsideToggle ?? (() => {})}>
        <div className="aside-card">
          <h3>Development</h3>
          <p>• Component registry</p>
          <p>• Debug tracking</p>
        </div>
        <div className="aside-card">
          <h3>Upcoming</h3>
          <p>• SSO & SCIM</p>
          <p>• API keys</p>
        </div>
        <div className="aside-card">
          <h3>Ideas</h3>
          <p>• Audit trail export</p>
          <p>• Theming preview</p>
        </div>
      </Drawer>
    </div>
  );
};

export default SettingsNetBody;
